import React, {useState} from "react";
import {withTranslation} from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import {mergeArrays} from "../../../utils/objects-util";
import {getFormattedTime} from "../../../utils/convertTime";

import LapseControl from "../LapseControl";
import IconButton from "../IconButton";

const ScheduleControl = ({ t, column, value, onPropChange }) => {
    const [item, setItem] = useState(null);

    const handleOnClose = () => {
        return new Promise(resolve=> {
            resolve();
            setItem(null);
        });
    }

    const handleOnChange = propValue => {
        return new Promise(resolve=> {
            resolve();
            if(column.isReadonly) {
                return;
            }
            onPropChange({ [column.accessor]: mergeArrays(value || [], [{ ...item, ...propValue}]) });
            setItem({ ...item, ...propValue});
        });
    }

    return (
        <div className={classNames("scheduleControl")}>
            <table className={classNames("scheduleItems")}>
                <thead></thead>
                <tbody>
                    {(value || []).filter(scheduleItem=> scheduleItem.id === 0 || scheduleItem.id).map(scheduleItem=> (
                        <tr key={`scheduleItem-${scheduleItem.id}`}>
                            <td>
                                <span className={classNames("link", { noitems: !scheduleItem.lapses || !scheduleItem.lapses.length })}
                                    onClick={()=> setItem(scheduleItem)}
                                >
                                    {scheduleItem.name}
                                </span>
                            </td>
                            <td>
                                {(scheduleItem.lapses || [])
                                    .map(lapse=> (`${getFormattedTime(lapse.open, lapse.close)}`))
                                    .join("; ")
                                }
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className={classNames("scheduleControlLayoutContainer", { open: !!item })}>
                <div className={classNames("empty")}></div>
                <div className={classNames("data")}>
                    <div className={classNames("header")}>
                        <div className={classNames("controls")}>
                            <IconButton isIcon={true} iconName={"cancel"} onClick={handleOnClose} />
                        </div>
                    </div>
                    <div className={classNames("scheduleItemEditContainer")}>
                        {!!item && (
                            <LapseControl value={item && item.lapses}
                                column={{
                                    accessor: "lapses",
                                    editTooltipText: t("settings.orderingmenu.MENU_BUSINESS_SHEDULE_EDIT_LAPSE_TOOLTIP_LABEL"),
                                    addTooltipText: t("settings.orderingmenu.MENU_BUSINESS_SHEDULE_ADD_LAPSE_TOOLTIP_LABEL"),
                                    deleteTooltipText: t("settings.orderingmenu.MENU_BUSINESS_SHEDULE_DELETE_LAPSE_TOOLTIP_LABEL")
                                }}
                                onPropChange={handleOnChange}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withTranslation()(ScheduleControl);
